import { render, staticRenderFns } from "./DoctorStatistic.vue?vue&type=template&id=518c9ac8&"
import script from "./DoctorStatistic.vue?vue&type=script&lang=js&"
export * from "./DoctorStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports